module.exports = __webpack_public_path__ + "img/chuyen_mon.f5fa5e2b.png";